import angular from 'angular';

/**
 * Data, that needs to be shared between sessions is stored in `$rootScope.globals`.
 * This service watches changes to the element and saves the state to cookies.
 * When the application loads, load the cookie value into `$rootScope.globals`.
 */

/* @ngInject */
export class LocalStorageService {
  constructor($location, $rootScope, $window) {
    'ngInject';

    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.$rootScope.globals = {};

    let self = this;

    // Register listener to auto save changes to the globals object
    this.$rootScope.$watch('globals', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        self.saveGlobalsToLocalStorage();
      }
    }, true);
  }

  /**
   * Find `globals` object saved in cookies and load them into `$rootScope`.
   * 
   * @returns {Promise} does not fail
   */
  loadGlobalsFromLocalStorage() {
    return new Promise((resolve, reject) => {
      if (this.$window.localStorage.getItem('globals') !== null) {
        this.$rootScope.globals = JSON.parse(this.$window.localStorage.getItem('globals'));
      }
      return resolve();
    });
  }

  /**
   * Saves `$rootScope.globals` to cookies for load in the next session.
   */
  saveGlobalsToLocalStorage() {
    this.$window.localStorage.setItem('globals', JSON.stringify(this.$rootScope.globals));
  }

  updateGlobal(key, value) {
    this.$rootScope.globals[key] = value;
    this.saveGlobalsToLocalStorage();
  }
}

export default angular.module('services.localStorage', [])
  .service('localStorageService', LocalStorageService)
  .name;